module.exports = __webpack_public_path__ + "img/Rectangle Copy 83@2x.b363d180.png";